import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { PosthogService } from './posthog.service';

@Injectable({ providedIn: 'root' })
export class HubspotCustomFormService {
  isBrowser: boolean;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    private posthogService: PosthogService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  generateCustomForm(type: string = 'bg-dark', coveragePageName?: string) {
    if (!this.isBrowser) return;
    try {
      // @ts-ignore
      hbspt.forms.create({
        region: 'na1',
        portalId: '8646839',
        formId: '9f08b229-6a77-4a68-aa47-412b7accf928',
        target: '#hubspotComponentForm',
        onFormReady: function ($form: any) {
          const submitButton = $form.find(
            'input[type="submit"].hs-button.primary.large'
          );
          const formElement = $form[0];
          const submitDiv = $form.find('.hs_submit');
          const emailField = $form.find(
            'div.hs_email.hs-email.hs-fieldtype-text.field.hs-form-field'
          );
          $form.find('iframe').css({
            height: 'auto',
            important: true,
          });
          $form.css({
            display: 'flex',
            'align-items': 'baseline',
            gap: '17px',
          });
          $form.find('div.actions').css({
            'margin-top': '0',
            'margin-bottom': '0',
            padding: '0',
          });
          emailField.css({
            'margin-bottom': '0',
            width: '100%',
          });
          $form.find('label').css({
            display: 'none',
          });
          $form
            .find('input[type="email"]')
            .attr('placeholder', 'E-mail address')
            .css({
              padding: '15px',
              'border-radius': '10.825px',
              border: '1.082px solid  #E6E7E9',
              background: '#fff',
              height: '48px',
            });

          submitButton.css({
            padding: '16px',
            'border-radius': '10px',
            background: ' #359EB4',
            height: '48px',
            'font-size': '15px',
            'font-weight': '600',
            border: 'none',
          });
          submitButton.hover(
            function () {
              submitButton.css('background-color', '#2a7e90');
            },
            function () {
              submitButton.css('background-color', '#359eb4');
            }
          );

          function applyConditionalWidth(emailField: any, submitDiv: any, submitButton: any) {
            const iframe = document.getElementsByClassName(
              'hs-form-iframe'
            )[0] as any;
            const iframeDocument = iframe.contentWindow.document;
            const submittedMessage =
              iframeDocument.querySelector('.submitted-message');
            if (window.innerWidth <= 480) {
              formElement.style.flexWrap = 'wrap';
              submitDiv.css('width', '100%');
              submitButton.css('width', '100%');
              emailField[0].style.flexGrow = 'unset';
              submitDiv[0].style.flexGrow = 'unset';
            } else if (window.innerWidth <= 768) {
              if (emailField[0]?.style) emailField.style.flexGrow = '3';
              if (submitDiv?.style) submitDiv.style.flexGrow = '1';
              if (submittedMessage?.style)
                submittedMessage.style.textAlign = 'left';
            } else {
              submitDiv.css('width', '');
              submitButton.css('width', '');
              formElement.style.flexWrap = 'nowrap';
              if (submittedMessage?.style)
                submittedMessage.style.textAlign = 'end';
            }
          }

          applyConditionalWidth(emailField, submitDiv, submitButton);
          window.addEventListener('resize', () => applyConditionalWidth(emailField, submitDiv, submitButton));
        },
        onFormSubmitted: () => {
          this.posthogService.capture('form_coverage_subscribe_submitted', {
            form_type: 'coverage_subscribe',
            hubspot_form_id: '9f08b229-6a77-4a68-aa47-412b7accf928',
            coverage_page_name: coveragePageName,
            page_url: typeof window !== 'undefined' ? window.location.href : '',
          });
          const iframe = document.getElementsByClassName(
            'hs-form-iframe'
          )[0] as any;
          setTimeout(function () {
            const iframeDocument = iframe.contentWindow.document;
            const submittedMessage =
              iframeDocument.querySelector('.submitted-message');

            if (submittedMessage) {
              if (type != 'bg-white') {
                submittedMessage.style.color = 'white';
              } else {
                submittedMessage.style.textAlign = 'center';
              }
              if (window.innerWidth <= 780) {
                submittedMessage.style.textAlign = 'left';
              } else {
                submittedMessage.style.textAlign = 'end';
              }
            }
          }, 100);
        },
      });
    } catch (_) {}
  }
  generateCustomFormStyle(form: any) {
    const $form = form;
    const submitButton = $form.find(
      'input[type="submit"].hs-button.primary.large'
    );
    const formElement = $form[0];
    const submitDiv = $form.find('.hs_submit');
    const emailField = $form.find(
      'div.hs_email.hs-email.hs-fieldtype-text.field.hs-form-field'
    );
    const linkTag = $form.find('a');
    $form.find('iframe').css({
      height: 'auto',
      important: true,
    });
    $form.find('div.actions').css({
      'margin-top': '24px',
      'margin-bottom': '0',
      padding: '0',
    });
    linkTag
      .css({
        color: '#ea566e',
        'text-decoration': 'none',
      })
      .hover(
        function () {
          linkTag.css({
            backgroundColor: '#ea566e',
            color: '#fff',
          });
        },
        function () {
          linkTag.css({
            color: '#ea566e',
            backgroundColor: 'transparent',
          });
        }
      );
    $form.find('img').css({
      marginBottom: '24px',
    });
    $form.find('label').css({
      marginBottom: '8px',
    });
    $form.find('div.hs-form-field').css({
      'margin-bottom': '24px',
    });
    $form.find('p').css({
      'margin-top': '0',
      'margin-bottom': '0',
    });
    $form.find('select').css({
      border: 'none',
      'border-radius': '10px',
      background: '#fff',
      height: '44px',
    });
    $form.find('input[type="email"]').css({
      padding: '15px',
      'border-radius': '10px',
      border: 'none',
      background: '#fff',
      height: '44px',
    });
    $form.find('input[type="text"]').css({
      padding: '15px',
      'border-radius': '10px',
      border: 'none',
      background: '#fff',
      height: '44px',
    });

    submitButton.css({
      'min-width': '100%',
      padding: '16px',
      'border-radius': '10px',
      background: ' #359EB4',
      height: '48px',
      'font-size': '15px',
      'font-weight': '600',
      border: 'none',
    });
    submitButton.hover(
      function () {
        submitButton.css('background-color', '#2a7e90');
      },
      function () {
        submitButton.css('background-color', '#359eb4');
      }
    );

    function applyConditionalWidth() {
      const iframe = document.getElementsByClassName(
        'hs-form-iframe'
      )[0] as any;
      const iframeDocument = iframe.contentWindow.document;
      const submittedMessage =
        iframeDocument.querySelector('.submitted-message');
      if (window.innerWidth <= 480) {
        formElement.style.flexWrap = 'wrap';
        submitDiv.css('width', '100%');
        submitButton.css('width', '100%');
        emailField.style.flexGrow = 'unset';
        submitDiv.style.flexGrow = 'unset';
      } else if (window.innerWidth <= 768) {
        if (emailField?.style) emailField.style.flexGrow = '3';
        if (submitDiv?.style) submitDiv.style.flexGrow = '1';
        if (submittedMessage?.style) submittedMessage.style.textAlign = 'left';
      } else {
        submitDiv.css('width', '');
        submitButton.css('width', '');
        formElement.style.flexWrap = 'nowrap';
        if (submittedMessage?.style) submittedMessage.style.textAlign = 'end';
      }
    }

    applyConditionalWidth();
    window.addEventListener('resize', applyConditionalWidth);
  }
}
